var map = {
	"./ai-technology.png": 6075,
	"./ai.png": 8178,
	"./circle-bg.svg": 2210,
	"./elipse.svg": 6369,
	"./feature-2.png": 6861,
	"./feature.png": 8552,
	"./gradient2.svg": 620,
	"./line4.svg": 540,
	"./logo-footer.png": 9177,
	"./logo.png": 3153,
	"./logo_ex.png": 1945,
	"./projectLogos/bloqin.png": 3069,
	"./projectLogos/flyandhealth.png": 1366,
	"./projectLogos/flyandhealth_ex.png": 396,
	"./projectLogos/schoolmeet-ai.png": 3020,
	"./projectLogos/wzero.png": 5069,
	"./projectLogos/wzero2.png": 4091,
	"./road-runner/avatar-circle.png": 2762,
	"./road-runner/avatar-circle2.png": 306,
	"./road-runner/avatar-circle3.png": 7787,
	"./road-runner/avatar-circle4.png": 1524,
	"./road-runner/avatar-circle5.png": 4557,
	"./road-runner/avatar-circle6.png": 3350,
	"./road-runner/avatar-circle7.png": 2367,
	"./school-logo.jpg": 7186,
	"./school-logo.webp": 5567,
	"./teacher-man-1.png": 4301,
	"./teacher-man-2.jpg": 8978,
	"./teacher-woman-1.jpg": 9219,
	"./teacher-woman-2.jpg": 6644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;